import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Convo: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_30860)'>
        <path
          d='M23 9.88663V18.2483C23 19.3495 22.161 20.2446 21.1317 20.2446H19.8619V22.6325C19.8619 22.7737 19.7858 22.9021 19.6668 22.9644C19.6192 22.9886 19.5692 23 19.518 23C19.4407 23 19.3645 22.972 19.3026 22.9186L16.1883 20.2446H11.3116C10.281 20.2446 9.44324 19.3482 9.44324 18.2483V13.353H7.81173L4.69737 16.027C4.63549 16.0804 4.55933 16.1084 4.48198 16.1084C4.432 16.1084 4.38083 16.0969 4.33323 16.0728C4.21422 16.0117 4.13806 15.882 4.13806 15.7409V13.353H2.86831C1.83777 13.353 1 12.4566 1 11.3567V2.99629C1 1.89515 1.83895 1 2.86831 1H12.6882C13.7187 1 14.5565 1.89642 14.5565 2.99629V7.89034H21.1325C22.163 7.89034 23 8.78676 23 9.88663ZM12.6872 12.6191C13.3382 12.6191 13.8677 12.0533 13.8677 11.3578V2.99736C13.8677 2.30185 13.3382 1.73601 12.6872 1.73601H2.86739C2.21646 1.73601 1.6869 2.30185 1.6869 2.99736V11.3578C1.6869 12.0533 2.21646 12.6191 2.86739 12.6191H4.48105C4.67026 12.6191 4.82496 12.7832 4.82496 12.9866V14.9753L7.47392 12.7005C7.53461 12.6484 7.61077 12.6191 7.68931 12.6191H12.6872ZM22.3121 9.88663C22.3121 9.19111 21.7826 8.62528 21.1316 8.62528H14.5556V11.3565C14.5556 12.4576 13.7167 13.3528 12.6873 13.3528H10.1312V18.2481C10.1312 18.9437 10.6607 19.5095 11.3117 19.5095H16.3096C16.3882 19.5095 16.4643 19.5387 16.525 19.5909L19.174 21.8656V19.877C19.174 19.6748 19.3275 19.5095 19.5179 19.5095H21.1315C21.7825 19.5095 22.312 18.9437 22.312 18.2481L22.3121 9.88663ZM18.3707 12.2453C18.2278 12.1105 18.0113 12.1258 17.8851 12.2771L15.586 15.0541L14.5626 13.766C14.44 13.6109 14.2234 13.5918 14.0783 13.7241C13.9331 13.8551 13.9152 14.0877 14.039 14.2416L15.3183 15.8526C15.3825 15.934 15.4777 15.981 15.5765 15.9823H15.5801C15.6788 15.9823 15.7728 15.9365 15.8371 15.8577L18.3992 12.7628C18.5253 12.6102 18.5111 12.3788 18.3695 12.244L18.3707 12.2453ZM9.94058 4.86404C9.80611 4.72035 9.58835 4.72035 9.45385 4.86404L7.77594 6.65688L6.09803 4.86404C5.96356 4.72035 5.7458 4.72035 5.61131 4.86404C5.47681 5.00772 5.47683 5.24039 5.61131 5.3841L7.28922 7.17695L5.61131 8.96979C5.47683 9.11348 5.47683 9.34615 5.61131 9.48986C5.67795 9.56107 5.76601 9.59794 5.85407 9.59794C5.94213 9.59794 6.03019 9.56234 6.09683 9.48986L7.77474 7.69702L9.45265 9.48986C9.51929 9.56107 9.60735 9.59794 9.69542 9.59794C9.78348 9.59794 9.87154 9.56234 9.93818 9.48986C10.0727 9.34618 10.0727 9.11351 9.93818 8.96979L8.26027 7.17695L9.93818 5.3841C10.0727 5.24042 10.0727 5.00775 9.93818 4.86404H9.94058Z'
          fill='url(#paint0_linear_12280_30860)'
          stroke='url(#paint1_linear_12280_30860)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_30860'
          x1='5.55569'
          y1='2.50015'
          x2='15.5813'
          y2='22.5942'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_30860'
          x1='5.55569'
          y1='2.50015'
          x2='15.5813'
          y2='22.5942'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_30860'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Convo;
